// removed by extract-text-webpack-plugin
module.exports = {"wide_row":"src-styles----team-module---wide_row---3Uiqk","hr_long":"src-styles----team-module---hr_long---3tXeJ","small_item":"src-styles----team-module---small_item---1SkM2","career_list":"src-styles----team-module---career_list---2wGTR","jumbo_p":"src-styles----team-module---jumbo_p---1B3Xi","career_row":"src-styles----team-module---career_row---2Qg2t","go_back":"src-styles----team-module---go_back---12Z2J"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/team.module.scss
// module id = 288
// module chunks = 59246933105914 224248516069615